import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledMuiButtonBase = (
  theme: Theme,
): BackstageOverrides['MuiButtonBase'] => ({
  root: {
    textTransform: 'none !important' as any,
    transition:
      'background-color 150ms ease, border-color 150ms ease, color 150ms ease',
    '&.Mui-focusVisible': {
      boxShadow: `0 0 0 4px ${theme.palette.primary.light}`,
    },
  },
});
